import { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AppContext } from '../../contexts/AppContext';
import PermissionsGate, { ROLES } from '../../utils/PermissionGate';

enum Type {
  Administration = 'Administration',
  UserSettings = 'User settings',
  CustomerSettings = 'Customer settings',
  Order = 'Order',
  Customers = 'Customers',
  Prices = 'Prices',
}

interface Props {
  currentTab: string;
  changeTab: (value: string) => void;
}

export function SettingsTabs(props: Props) {
  const location = useLocation();
  const { isHumphreeHome, isBusinessCustomer } = useContext(AppContext);

  return (
    <div className='flex flex-wrap items-center w-full border-b border-gray-10 gap-x-8 mt-10'>
      <Link
        to='admin'
        className={`py-4 cursor-pointer w-max ${
          !location.pathname.includes('order') &&
          !location.pathname.includes('customers') &&
          !location.pathname.includes('prices') &&
          !location.pathname.includes('user-settings') &&
          !location.pathname.includes('customer-settings') &&
          'border-b-2 border-gray-100'
        }`}
        onClick={() => props.changeTab(Type.Administration)}
      >
        <span
          className={`${
            !location.pathname.includes('order') &&
            !location.pathname.includes('customers') &&
            !location.pathname.includes('prices') &&
            !location.pathname.includes('user-settings') &&
            !location.pathname.includes('customer-settings')
              ? 'font-bold'
              : 'font-normal'
          } text-primary-400 prose-paragraphBase`}
        >
          Administration
        </span>
      </Link>

      <Link
        to='user-settings'
        className={`py-4 cursor-pointer w-max ${
          location.pathname.includes('user-settings') && 'border-b-2 border-gray-100'
        }`}
        onClick={() => props.changeTab(Type.UserSettings)}
      >
        <span
          className={`${
            location.pathname.includes('user-settings') ? 'font-bold' : 'font-normal'
          } text-primary-400 prose-paragraphBase`}
        >
          User settings
        </span>
      </Link>

      {!isHumphreeHome && (
        <PermissionsGate roles={[ROLES.admin, ROLES.oemAdmin]} rejected={undefined}>
          <Link
            to='customer-settings'
            className={`py-4 cursor-pointer w-max ${
              location.pathname.includes('customer-settings') && 'border-b-2 border-gray-100'
            }`}
            onClick={() => props.changeTab(Type.CustomerSettings)}
          >
            <span
              className={`${
                location.pathname.includes('customer-settings') ? 'font-bold' : 'font-normal'
              } text-primary-400 prose-paragraphBase`}
            >
              Customer settings
            </span>
          </Link>
        </PermissionsGate>
      )}

      {/* Business customer view */}
      {isBusinessCustomer && (
        <>
          <Link
            to='order'
            className={`py-4 cursor-pointer w-max ${
              location.pathname.includes('order') && 'border-b-2 border-gray-100'
            }`}
            onClick={() => props.changeTab(Type.Order)}
          >
            <span
              className={`${
                location.pathname.includes('order') ? 'font-bold' : 'font-normal'
              } text-primary-400 prose-paragraphBase`}
            >
              Order
            </span>
          </Link>
          <Link
            to='customers'
            className={`py-4 cursor-pointer w-max ${
              location.pathname.includes('customers') && 'border-b-2 border-gray-100'
            }`}
            onClick={() => props.changeTab(Type.Customers)}
          >
            <span
              className={`${
                location.pathname.includes('customers') ? 'font-bold' : 'font-normal'
              } text-primary-400 prose-paragraphBase`}
            >
              Customers
            </span>
          </Link>
        </>
      )}
      {/* Indirect customer view */}
      {!isHumphreeHome && !isBusinessCustomer && (
        <Link
          to='prices'
          className={`py-4 cursor-pointer w-max ${
            location.pathname.includes('prices') && 'border-b-2 border-gray-100'
          }`}
          onClick={() => props.changeTab(Type.Prices)}
        >
          <span
            className={`${
              location.pathname.includes('prices') ? 'font-bold' : 'font-normal'
            } text-primary-400 prose-paragraphBase`}
          >
            Prices
          </span>
        </Link>
      )}
    </div>
  );
}
